// 00 - STATE
let bfMap = null;
let bfClusterer = null;
let bfMarkers = [];
let bfGeocoder = null;

const bfZipPattern = /^\d{5}$/;

function bfFormatAddress(location) {
  return [location.street, location.city, location.state, location.zip]
    .filter(Boolean)
    .join(", ");
}

function bfDirectionsUrl(location) {
  return (
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent(bfFormatAddress(location))
  );
}

// 01 - MAP (Google Maps async callback)
window.rhinegeistInitBeerFindMap = function () {
  const mapEl = document.querySelector("[data-beer-find-map]");
  if (!mapEl || !window.google) {
    return;
  }

  const config = window.rhinegeistBeerFinder || {};
  const center = config.fallbackCenter || { lat: 39.1172664, lng: -84.5201012 };

  bfMap = new google.maps.Map(mapEl, {
    center,
    zoom: 11,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM,
    },
  });

  bfGeocoder = new google.maps.Geocoder();

  if (window.markerClusterer) {
    bfClusterer = new markerClusterer.MarkerClusterer({
      map: bfMap,
      markers: [],
    });
  }
};

function bfUpdateMapMarkers(locations, onMarkerClick) {
  if (!bfMap) {
    return;
  }

  bfMarkers.forEach((marker) => marker.setMap(null));
  bfMarkers = [];

  if (bfClusterer) {
    bfClusterer.clearMarkers();
  }

  const bounds = new google.maps.LatLngBounds();

  locations.forEach((location, index) => {
    const lat = parseFloat(location.lat);
    const lng = parseFloat(location.long);
    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return;
    }

    const position = { lat, lng };
    const marker = new google.maps.Marker({
      position,
      title: location.dba || "",
    });
    marker.addListener("click", () => onMarkerClick(index, marker));

    bfMarkers.push(marker);
    bounds.extend(position);
  });

  if (bfClusterer) {
    bfClusterer.addMarkers(bfMarkers);
  } else {
    bfMarkers.forEach((marker) => marker.setMap(bfMap));
  }

  if (bfMarkers.length) {
    bfMap.fitBounds(bounds);
  }
}

function bfGeocodeAddress(address) {
  if (!bfGeocoder) {
    return Promise.reject(
      new Error(
        "Map service is unavailable. Please search by zip code instead.",
      ),
    );
  }

  return new Promise((resolve, reject) => {
    bfGeocoder.geocode({ address }, (results, status) => {
      if (status !== "OK" || !results.length) {
        reject(
          new Error(
            "We couldn't find that location. Please try a different address or zip code.",
          ),
        );
        return;
      }

      const result = results[0];
      const zipComponent = result.address_components.find((component) =>
        component.types.includes("postal_code"),
      );

      resolve({
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng(),
        zip: zipComponent ? zipComponent.short_name : "",
      });
    });
  });
}

// 02 - GEOLOCATION
function bfRequestBrowserLocation(onStart, onSuccess, onError) {
  if (!navigator.geolocation) {
    onError("Your browser does not support location detection.");
    return;
  }

  onStart();

  navigator.geolocation.getCurrentPosition(
    (position) => {
      onSuccess(position.coords.latitude, position.coords.longitude);
    },
    (err) => {
      const message =
        err.code === err.PERMISSION_DENIED
          ? "Location access was denied. Please enter an address or zip code."
          : "Unable to detect your location. Please enter an address or zip code.";
      onError(message);
    },
    { timeout: 10000 },
  );
}

// 03 - RESULTS + SEARCH
document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-beer-finder]");
  if (!root || !window.rhinegeistBeerFinder) {
    return;
  }

  const { ajaxUrl, nonce, initialState } = window.rhinegeistBeerFinder;

  const CURRENT_LOCATION_LABEL = "Current Location";
  let bfCurrentLocationCoords = null;

  const dialog = document.getElementById("bf-welcome-dialog");
  const dismissBtn = dialog?.querySelector(".beer-find__dismiss");
  const welcomeForm = dialog?.querySelector("[data-beer-welcome-form]");
  const welcomeBrandSelect = dialog?.querySelector("[data-beer-welcome-brand]");
  const welcomeErrorEl = dialog?.querySelector("[data-beer-welcome-error]");

  const header = root.querySelector(".beer-find__header");
  const form = root.querySelector("[data-beer-find-form]");
  const brandSelect = root.querySelector("[data-beer-find-brand]");
  const resultsEl = root.querySelector("[data-beer-find-results]");
  const placeholderEl = root.querySelector("[data-beer-find-placeholder]");
  const errorEl = root.querySelector("[data-beer-find-error]");

  const showError = (message) => {
    errorEl.textContent = message;
    errorEl.hidden = false;
  };

  const clearError = () => {
    errorEl.hidden = true;
    errorEl.textContent = "";
  };

  const showWelcomeError = (message) => {
    if (!welcomeErrorEl) {
      return;
    }
    welcomeErrorEl.textContent = message;
    welcomeErrorEl.hidden = false;
  };

  const clearWelcomeError = () => {
    if (!welcomeErrorEl) {
      return;
    }
    welcomeErrorEl.hidden = true;
    welcomeErrorEl.textContent = "";
  };

  const closeDialog = () => {
    if (dialog?.open) {
      dialog.close();
    }
  };

  const revealSecondaryForm = () => {
    header?.removeAttribute("hidden");
  };

  const revealResultsPanel = () => {
    const resultsEl = document.getElementById("bf-results");
    if (!!resultsEl) {
      resultsEl.classList.add("beer-find__results--open");
    }
  };

  const syncSecondaryForm = (locationText, brand, miles) => {
    form.location.value = locationText;
    if (brandSelect) {
      brandSelect.value = brand || "";
    }
    form.miles.value = miles;
  };

  const updateQueryParams = (params) => {
    const url = new URL(window.location.href);
    url.search = "";
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        url.searchParams.set(key, value);
      }
    });
    window.history.replaceState({}, "", url);
  };

  const loadBrands = async () => {
    try {
      const body = new FormData();
      body.append("action", "rhinegeist_find_brands");
      body.append("nonce", nonce);

      const response = await fetch(ajaxUrl, {
        method: "POST",
        body,
        credentials: "same-origin",
      });
      const payload = await response.json();
      if (!payload.success) {
        return;
      }

      (payload.data.brands || []).forEach((brand) => {
        [brandSelect, welcomeBrandSelect].forEach((select) => {
          if (!select) {
            return;
          }
          const option = document.createElement("option");
          option.value = brand;
          option.textContent = brand;
          select.appendChild(option);
        });
      });

      if (initialState?.brand) {
        [brandSelect, welcomeBrandSelect].forEach((select) => {
          if (select) {
            select.value = initialState.brand;
          }
        });
      }
    } catch (err) {
      // Brand list is a progressive enhancement; searches still work without it.
    }
  };

  const highlightResult = (index) => {
    resultsEl.querySelectorAll("[data-beer-find-result]").forEach((el) => {
      el.classList.toggle(
        "is-active",
        Number(el.dataset.beerFindResult) === index,
      );
    });
  };

  const renderResults = (locations) => {
    resultsEl.innerHTML = "";

    if (!locations.length) {
      const empty = document.createElement("p");
      empty.className = "beer-find__placeholder";
      empty.textContent =
        "No locations found. Try a larger distance or a different beer.";
      resultsEl.appendChild(empty);
      return;
    }

    locations.forEach((location, index) => {
      const item = document.createElement("article");
      item.className = "beer-find__result";
      item.dataset.beerFindResult = String(index);

      item.innerHTML = `
        <h3>${location.dba || ""}</h3>
        <p>${bfFormatAddress(location)}</p>
        ${
          location.phoneFormatted
            ? `<p><a href="tel:${location.phone}">${location.phoneFormatted}</a></p>`
            : ""
        }
        <a class="beer-find__directions" href="${bfDirectionsUrl(
          location,
        )}" target="_blank" rel="noopener">Get Directions</a>
      `;

      item.addEventListener("click", () => {
        highlightResult(index);
        const marker = bfMarkers[index];
        if (marker && bfMap) {
          bfMap.panTo(marker.getPosition());
        }
      });

      resultsEl.appendChild(item);
    });

    bfUpdateMapMarkers(locations, (index) => {
      highlightResult(index);
      resultsEl
        .querySelector(`[data-beer-find-result="${index}"]`)
        ?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  };

  const search = async (params, onError) => {
    resultsEl.classList.add("is-loading");

    try {
      const body = new FormData();
      body.append("action", "rhinegeist_find_locations");
      body.append("nonce", nonce);
      Object.entries(params).forEach(([key, value]) => body.append(key, value));

      const response = await fetch(ajaxUrl, {
        method: "POST",
        body,
        credentials: "same-origin",
      });
      const payload = await response.json();

      if (!payload.success) {
        onError(
          payload.data?.message || "Something went wrong. Please try again.",
        );
        return false;
      }

      updateQueryParams(params);
      renderResults(payload.data.locations || []);
      return true;
    } catch (err) {
      onError("Something went wrong. Please try again.");
      return false;
    } finally {
      resultsEl.classList.remove("is-loading");
    }
  };

  const runSearch = async (location, brand, miles, onError) => {
    onError(null);
    placeholderEl?.remove();

    const params = { miles };
    if (brand) {
      params.brand = brand;
    }

    if (location === CURRENT_LOCATION_LABEL && bfCurrentLocationCoords) {
      params.lat = bfCurrentLocationCoords.lat;
      params.lng = bfCurrentLocationCoords.lng;
      return search(params, onError);
    }

    if (bfZipPattern.test(location)) {
      params.zip = location;
      return search(params, onError);
    }

    try {
      const geo = await bfGeocodeAddress(location);
      params.lat = geo.lat;
      params.lng = geo.lng;
      if (geo.zip) {
        params.zip = geo.zip;
      }
      return search(params, onError);
    } catch (err) {
      onError(err.message);
      return false;
    }
  };

  const runSearchByCoords = async (lat, lng, brand, miles, onError) => {
    onError(null);
    placeholderEl?.remove();

    const params = { miles, lat, lng };
    if (brand) {
      params.brand = brand;
    }

    try {
      const geo = await bfGeocodeAddress(`${lat}, ${lng}`);
      if (geo.zip) {
        params.zip = geo.zip;
      }
    } catch (_) {
      // reverse geocode failed — proceed with lat/lng only
    }

    return search(params, onError);
  };

  loadBrands();

  if (!initialState?.hasState) {
    bfRequestBrowserLocation(
      () => {},
      async (lat, lng) => {
        const brand = welcomeBrandSelect ? welcomeBrandSelect.value : "";
        const miles = welcomeForm ? welcomeForm.miles.value : "25";
        const succeeded = await runSearchByCoords(lat, lng, brand, miles, showWelcomeError);

        if (succeeded) {
          bfCurrentLocationCoords = { lat, lng };
          syncSecondaryForm(CURRENT_LOCATION_LABEL, brand, miles);
          revealSecondaryForm();
          revealResultsPanel();
          closeDialog();
        }
      },
      () => {
        // geolocation denied or unavailable — leave dialog open for manual entry
      },
    );
  }

  if (initialState?.hasState) {
    closeDialog();
    revealSecondaryForm();
    revealResultsPanel();
    placeholderEl?.remove();

    const params = { miles: initialState.miles };
    if (initialState.brand) {
      params.brand = initialState.brand;
    }
    if (initialState.zip) {
      params.zip = initialState.zip;
    }
    if (initialState.lat && initialState.lng) {
      params.lat = initialState.lat;
      params.lng = initialState.lng;
    }

    search(params, showError);
  }

  dismissBtn?.addEventListener("click", () => {
    closeDialog();
    revealSecondaryForm();
    revealResultsPanel();
  });

  welcomeForm?.addEventListener("submit", async (event) => {
    event.preventDefault();

    const location = welcomeForm.location.value.trim();
    if (!location) {
      return;
    }

    const brand = welcomeBrandSelect ? welcomeBrandSelect.value : "";
    const miles = welcomeForm.miles.value;

    const succeeded = await runSearch(location, brand, miles, (message) => {
      if (message) {
        showWelcomeError(message);
      } else {
        clearWelcomeError();
      }
    });

    if (succeeded) {
      syncSecondaryForm(location, brand, miles);
      revealSecondaryForm();
      revealResultsPanel();
      closeDialog();
    }
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    const location = form.location.value.trim();
    if (!location) {
      return;
    }

    const brand = brandSelect ? brandSelect.value : "";
    const miles = form.miles.value;

    await runSearch(location, brand, miles, (message) => {
      if (message) {
        showError(message);
      } else {
        clearError();
      }
    });
  });
});
